import moment from 'moment';

import { getDateName } from '../TextStoreHelpers/TextStoreHelpers';

export class DateDisplayHelper {
    static getDateText(
        date: moment.Moment,
        format: string = 'DD.MM.YYYY'
    ): string {
        const today = moment().utcOffset('+0300'),
            yesterday = moment()
                .utcOffset('+0300')
                .subtract(1, 'day'),
            isToday = date.isSame(today, 'day'),
            isYesterday = date.isSame(yesterday, 'day');

        return isToday
            ? getDateName('today')
            : isYesterday
            ? getDateName('yesterday')
            : date.format(format);
    }
}
